/**
 * The public feed: its tab, routes, and the ways of posting to it. Off unless
 * REACT_APP_FEED_ENABLED=true at build time. Share links and PDFs don't depend on it.
 */
export const FEED_ENABLED = process.env.REACT_APP_FEED_ENABLED === "true";
